import { Component, Input, OnInit } from '@angular/core';
import {
  UrlPreviewData,
  UrlPreviewService,
} from '../../services/url-preview.service';

@Component({
  selector: 'app-url-preview',
  templateUrl: './url-preview.component.html',
  styleUrls: ['./url-preview.component.scss'],
})
export class UrlPreviewComponent implements OnInit {
  @Input() url: string;
  previewData: UrlPreviewData | null = null;
  loading = true;
  error = false;

  constructor(private urlPreviewService: UrlPreviewService) {}

  ngOnInit() {
    if (this.url) {
      this.loadPreview();
    }
  }

  private loadPreview() {
    this.loading = true;
    this.error = false;

    this.urlPreviewService.getUrlPreview(this.url).subscribe({
      next: data => {
        this.previewData = data;
        this.loading = false;
      },
      error: () => {
        this.error = true;
        this.loading = false;
      },
    });
  }

  openUrl() {
    if (this.url) {
      window.open(this.url, '_blank');
    }
  }
}

